module.exports = __webpack_public_path__ + "static/media/golf.01347dc4.svg";